import type { IMasterDataProductPriceRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataProductPriceDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataProductPriceUseCase {
  private readonly repository: IMasterDataProductPriceRepository;

  constructor(repository: IMasterDataProductPriceRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataProductPriceDTO) {
    return this.repository.createProductPrice(params);
  }
}
